export interface CloudProps {
  src: string;
  top: string;
  width: string;
  animationDuration: string;
  opacity: number;
  zIndex: number;
  id: string;
}

export const cloudImages = [
  "cloud-0.png",
  "cloud-1.png",
  "cloud-2.png",
  "cloud-3.png",
  "cloud-4.png",
  "cloud-5.png",
  "cloud-6.png",
  "cloud-8.png",
];